<template>
  <div class="mobile-factoring-project-container">
    <!-- 顶部 -->
    <el-row>
      <el-col :span="24">
        <div class="content-col">
          <div class="content-title">流程名称</div>
          <div class="init-content top-title">{{processDetail.process?processDetail.process.processDefinitionName:''}}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="content-col">
          <div class="content-title">业务主办、协办</div>
          <div class="init-content">{{basicInfoData.managerUserName?basicInfoData.managerUserName:''}}{{basicInfoData.assistUserName?`、${basicInfoData.assistUserName}`:''}}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="content-col">
          <div class="content-title">流水号</div>
          <div class="init-content">{{basicInfoData.number?basicInfoData.number:''}}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="content-col">
          <div class="content-title">提交时间</div>
          <div class="init-content">{{basicInfoData.createTime}}</div>
        </div>
      </el-col>
    </el-row>

    <el-tabs v-model="activeName" @tab-click="handleClick" stretch="true">
      <el-tab-pane label="审批信息" name="first">
        <div class="panel-container">
          <DetailList :listData="basicInfoData" />
          <!-- 审批意见 -->
          <AuditInfo
            ref="auditInfo"
            :formDetailData="auditFormData"
            :isEditable="processDetail.process?processDetail.process.isEditable:false"
            :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
            @changeFormData="changeFormData"
          />
          <!-- 会签意见 -->
          <CommentStep
            ref="commentStep"
            :commentList="commentList"
            :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
          />
          <!-- 流程记录 -->
          <CommentTable :flowData="flowData" />

          <!-- 与navbar同高的块 -->
          <div class="bottom-block" style="height: 2.2rem;" />
        </div>
      </el-tab-pane>

      <el-tab-pane label="客户概况" name="second">
        <CustomerInfo :listData="customerDetail"/>
      </el-tab-pane>

      <el-tab-pane label="公共附件" name="third">
        <BatchFileList
          v-if="uploadPermissionNameOne"
          :fileMenuUrlname="uploadPermissionNameOne"
          :fileMenuName="uploadPermissionNameTwo"
          :fileOtherId="basicInfoData.projectInfoId"
        />
      </el-tab-pane>
    </el-tabs>

    <!-- v-if="presentFlow.assignee == userInfo.user_id && processDetail.process.status == 'todo'" -->
    <BottomLine
      ref="bottoms"
      v-if="processDetail.process && processDetail.process.status == 'todo'"
      :processDetail="processDetail"
      :formDetailData="auditFormData"
      :mobileFormChange="mobileFormChange"
      @flowNext="flowNextMobile"
      @flowBack="flowBack"
      @refreshData="refreshData"
    />    
  </div>
</template>
<script>
import { getFactoringDetail } from '@/api/factoring/factoring'
import { getQuotaDetail } from "@/api/factoring/factoringScheme";
import {getCustomerDetail} from '@/api/factoring/factoringCustomer'
import BatchFileList from "../../components/batchFileList"
import AuditInfo from "@/components/workflowComponents/mobile/auditInfo"
import BottomLine from "@/components/workflowComponents/mobile/bottomLine"
import CommentTable from "@/components/workflowComponents/mobile/commentTable"
import CommentStep from "@/components/workflowComponents/mobile/commentStep"
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util"
import { mapGetters } from "vuex";
// 业务明细
import DetailList from "./components/list"
import CustomerInfo from "./components/customerInfo"
export default {
  name:'MobileFactoringBuildProject',
  mixins: [workFlow, util],
  data() {
    return {
      id: '',
      activeName: 'first',
      processKey: "rzzl_if_projectstart",
      detailFormUrl: "/factoring/buildProject/projectDetail",
      basicInfoData: {},
      customerDetail: {}
    }
  },
  components: {
    AuditInfo,
    BatchFileList,
    BottomLine,
    DetailList,
    CommentTable,
    CommentStep,
    CustomerInfo
  }, 
  computed: {
    ...mapGetters(["workFlowData", "userInfo", "workFlowState"]),
  },   
  mounted() {
    this.id = this.$route.params.id;
    this.queryFactoringDetail(this.id);
  },
  methods: {
    async queryFactoringDetail(id) {
      let res = await getFactoringDetail({id: id})
      if(res.data.code == 200) {
        this.basicInfoData = res.data.data
        // 处理表单数据
        this.basicInfoData.projectType = this.basicInfoData.projectType?`${this.basicInfoData.projectType}`:this.basicInfoData.projectType
        this.basicInfoData.poundageChargeType = this.basicInfoData.poundageChargeType?`${this.basicInfoData.poundageChargeType}`:this.basicInfoData.poundageChargeType
        this.basicInfoData.cashDepositChargeType = this.basicInfoData.cashDepositChargeType?`${this.basicInfoData.cashDepositChargeType}`:this.basicInfoData.cashDepositChargeType
        this.basicInfoData.cashDepositReturnType = this.basicInfoData.cashDepositReturnType?`${this.basicInfoData.cashDepositReturnType}`:this.basicInfoData.cashDepositReturnType
        this.basicInfoData.marginReturnType = this.basicInfoData.marginReturnType?`${this.basicInfoData.marginReturnType}`:this.basicInfoData.marginReturnType
        this.basicInfoData.guaranteeMethod = this.basicInfoData.guaranteeMethod?`${this.basicInfoData.guaranteeMethod}`:this.basicInfoData.guaranteeMethod
        this.basicInfoData.projectComeFromStr = await this.queryDict(this.basicInfoData.projectComeFrom, '/api/blade-system/dict-biz/dictionary?code=project_source')
        this.basicInfoData.repaymentTypeStr = await this.queryDict(this.basicInfoData.repaymentType, '/api/blade-system/dict-biz/dictionary?code=factoring_repay_type')
        
        this.basicInfoData.factoringCredit = this.basicInfoData.factoringCredit == '-1'?0:`${Number(this.basicInfoData.factoringCredit).toFixed(2)}`

        // 查询客户详情
        this.queryCustomerDetail(this.basicInfoData)
        // 查询报价方案数据
        this.queryQuatoPlan(this.basicInfoData.blContractRentalId)
      }
    },

    async queryCustomerDetail(data) {
      let res = await getCustomerDetail({id: data.sellerCustId})
      if(res.data.code == 200){
        let list = [
          { code: "cust_type_rzzl", name: "custType" },
          { code: "bl_cust_attribute", name: "custAttribute" },
          { code: "enterprise_type", name: "enterpriseType" },
          { code: "enterprise_scale", name: "enterpriseScale" },
          { code: "cust_source", name: 'custSource'},
          { code: "cust_category", name: "custCategory"}
        ]
        let returnData = await this.dictionaryMap(list, res.data.data)
        // console.info(returnData, '1111111')
        this.customerDetail = {
          ...returnData
        }

        this.$set(this.customerDetail, 'custCompanyState', data.custCompanyState)
        this.$set(this.customerDetail, 'custProductSalesState', data.custProductSalesState)
        this.$set(this.customerDetail, 'custPropertyState', data.custPropertyState)
        this.$set(this.customerDetail, 'custOther', data.custOther)

        this.basicInfoData.industry = this.customerDetail.industryStr
        this.customerDataReady = true

        // 查询当前流程任务数据
        this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
        // 设置流程表单路径
        this.queryProcessFormDetail(this.processDefinedId)

        this.queryFlowData(this.basicInfoData.flowableId)
      }
    },

    async queryQuatoPlan(rentId) {
      let self = this
      let res = await getQuotaDetail({id: rentId})
      if(res.data.code == 200) {
        let data = res.data.data
        let newData = {}
        newData.quotaPlanName = data.name
        // 年租息率
        newData.annualInterestRateStr = `${(Number(data.annualInterestRate)*100).toFixed(4)}%`
        newData.blContractRentalId = data.id
        newData.factoringCredit = data.quotationPrice?`${Number(data.quotationPrice).toFixed(2)}`: '0'
        newData.factoringCreditStr = data.quotationPrice?`${this.getMoney(Number(data.quotationPrice))}元`: '0'
        newData.financingMaturity = data.leaseTerm?`${data.leaseTerm}天`: '0'

        newData.gracePeriod = data.gracePeriodDay && data.gracePeriodDay != '-1'?`${data.gracePeriodDay}天`: ''
        newData.graceRateStr = data.graceInterestRate && Number(data.graceInterestRate) != -1?`${(Number(data.graceInterestRate)*100).toFixed(2)}%`:''
        // 手续费
        let poundageData = data.outlays.length>0?data.outlays.filter(item => {return item.dictMainOutlayType == 1}):[]
        newData.poundage = poundageData.length>0?`${Number(poundageData[0].outlayAmount).toFixed(2)}`: '0'
        newData.poundageStr = poundageData.length>0?`${this.getMoney(Number(poundageData[0].outlayAmount))}元`: '0元'
        newData.poundageChargeType = poundageData.length>0?poundageData[0].outlayWay: ''
        // 保证金
        let casData = data.outlays.length>0?data.outlays.filter(item => {return item.dictMainOutlayType == 2}):[]
        newData.cashDeposit = casData.length>0?`${Number(casData[0].outlayAmount).toFixed(2)}`: '0'
        newData.cashDepositStr = casData.length>0?`${this.getMoney(Number(casData[0].outlayAmount))}元`: '0元'
        newData.cashDepositChargeType = casData.length>0?casData[0].outlayWay: ''
        newData.cashDepositReturnType = casData.length>0?`${casData[0].expirationTreatment}`: ''

        newData.overdueInterestRateStr = data.overdueInterestRate && Number(data.overdueInterestRate) != -1 ?`${(Number(data.overdueInterestRate)*100).toFixed(2)}%`:'0'
        newData.downParment = data.downPayment?data.downPayment: '0'
        newData.downParmentStr = data.downPayment?data.downPayment.split(',')[1]: '0'
        newData.downParmentUsageRate = data.downParmentUsageRate?data.downParmentUsageRate: '0'
        newData.xirr = data.xirr?data.xirr: '0'
        newData.xirrStr = data.xirr?`${(Number(data.xirr)*100).toFixed(4)}%`: '0'

        let asyncOne = this.queryDict(newData.poundageChargeType, '/api/blade-system/dict-biz/dictionary?code=fee_collection_method')
        let asyncTwo = this.queryDict(newData.cashDepositChargeType, '/api/blade-system/dict-biz/dictionary?code=fee_collection_method')
        let asyncThree = this.queryDict(newData.cashDepositReturnType, '/api/blade-system/dict-biz/dictionary?code=expiration_treatment')
        Promise.all([asyncOne,asyncTwo, asyncThree]).then(res => {
            newData.poundageChargeTypeStr = res[0]
            newData.cashDepositChargeTypeStr = res[1]
            newData.cashDepositReturnTypeStr = res[2]
            self.basicInfoData = Object.assign({}, self.basicInfoData, newData)
        })
      }
    },

    async flowNextMobile(formData,taskInfoList) {
      let processInsId = this.processDetail.process.processInstanceId
      let taskId = this.processDetail.process.taskId
      let taskName = this.processDetail.process.taskName
      // 流程表单数据
      let variables = formData

      let res= {
        data:{
          code:'',
          msg:'失败'
        }
      }
      if(taskInfoList&&taskInfoList.length>0){
           res= await this.selectPeopleFlowNext(
                taskId,
                taskName,
                this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                variables,
                JSON.stringify(taskInfoList),
            )
        
        }else {
           res= await this.taskFlowNext(
                taskId,
                processInsId,
                this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                variables
            )
        }
      if(res.data.code == 200 ){
        this.$refs.bottoms.closeDialog()
        this.refreshData()
        this.$message({
          message: '转交下一步操作成功',
          type: 'success'
        })
      }else{
        // this.$notify.warn(res.data.msg);
        this.$message({
          message: res.data.msg,
          type: 'warning'
        })
      }
    },

    refreshData() {
      this.queryFactoringDetail(this.id)
      this.getBasicConfigData()
    },    
  }
}
</script>
<style lang="scss" scoped>
.mobile-factoring-project-container{
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: #f9f9f9;
  .top-title{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 0.3rem;
  }
  /deep/ .el-tabs.el-tabs--top {
      border-top: 0.5px solid #f2f2f2;
      .el-tabs__header{
        background-color: #fff;
      }
      .el-tabs__item{
        font-size: .38rem !important;
      }
  }
  /deep/ .el-message{
    min-width: 7rem !important;
  }  
  .content-col{
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    border-bottom: 0.5px solid #f2f2f2;
    background: #fff;
    .content-title{
      text-align: center;
      font-size: 0.38rem;
      line-height: .5rem;
      height: .5rem;
      color: #333;
    }
    .init-content{
      color: #999;
      font-size: .36rem;
      line-height: .5rem;
      height: .5rem;
      text-align: center;      
    }
  }
  .panel-container{
    width: 100%;
    // padding-left: .25rem;
    // padding-right: .25rem;
  }
}
</style>